import { SeatsIOSeat } from "~components/reservation/constants";
import { EventQuery } from "~graphql/sdk";

export const getActivePromotions = (
  promotions: EventQuery["event"]["multiBuyPromotions"],
  seats: SeatsIOSeat[]
) => {
  const activePromotions = promotions?.reduce(
    (acc, curr: typeof promotions[number]) => {
      const getType = curr.getTicketType; // TODO: membership || curr?.getMembershipType;
      const buyType = curr.buyTicketType; // TODO: membership || curr?.buyMembershipType;

      if (buyType && getType) {
        const buySeats = seats?.filter(
          (
            { ticketType } // TODO: membership , membershipType }) =>
          ) =>
            (ticketType?.value || ticketType?.id) === // TODO: membership || membershipType?.id) ===
            buyType?.id
        );

        const getSeats = seats?.filter(
          (
            { ticketType } // TODO: membership , membershipType }) =>
          ) =>
            (ticketType?.value || ticketType?.id) === // TODO: membership || membershipType?.id) ===
            getType.id
        );

        const buyTotal = buySeats?.length;
        const buySeatQty = Math.floor(buyTotal / curr.buyQuantity);

        const getTotal = getSeats?.length;

        const giftedQty =
          buySeatQty * curr.getQuantity <= getTotal
            ? buySeatQty * curr.getQuantity
            : getTotal;

        if (
          getSeats &&
          buySeats &&
          buySeats.length >= curr.buyQuantity &&
          (getSeats.length >= curr.getQuantity || curr.price === 0)
        ) {
          const activePromo = [
            ...buySeats.map((buy) => ({
              promotion: curr,
              ...buy,
              type: "buying",
            })),
            ...getSeats?.slice(0, giftedQty).map((get) => ({
              promotion: curr,
              ...get,
              type: "getting",
            })),
          ];

          return [
            ...acc,
            {
              ...curr,
              seats: activePromo,
              isActive: getSeats?.length > 0,
            },
          ];
        }
      }

      return [
        ...acc,
        {
          ...curr,
          isActive: false,
        },
      ];
    },
    []
  );

  /** @note we'll return the first promotion that is active **/
  return activePromotions?.find((promo) => promo?.isActive)?.seats ?? [];
};
